export default {
      id: "facebook-negative-usage",
      viewBox: "0 0 512 512",
      url: "/assets/svg/" + "sprite.svg#facebook-negative-usage",
      toString: function () {
        return this.url;
      }
    }